import { render, staticRenderFns } from "./BonusCategory.vue?vue&type=template&id=508b5530"
import script from "./BonusCategory.vue?vue&type=script&lang=js"
export * from "./BonusCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports